import { BadgeGlyph, SnippetGlyph, FullMessageGlyph } from '@/components/outbound/ConfigGlyphs'
import ToggleOptionList from '@/components/ui/ToggleOptionList'

interface Agent {
  id: number
  name: string
  email: string
  avatar_url: string | null
  role: string
}

interface ChatConfigPanelProps {
  agents: Agent[]
  sentByAgentId: number
  onAgentChange: (id: number) => void
  deliveryStyle: 'badge' | 'snippet' | 'full'
  onDeliveryStyleChange: (style: 'badge' | 'snippet' | 'full') => void
  collectEmail: boolean
  onCollectEmailChange: (checked: boolean) => void
}

export default function ChatConfigPanel({
  agents,
  sentByAgentId,
  onAgentChange,
  deliveryStyle,
  onDeliveryStyleChange,
  collectEmail,
  onCollectEmailChange,
}: ChatConfigPanelProps) {
  return (
    <div className="w-[280px] flex-shrink-0 border-r border-gray-200 bg-white overflow-y-auto p-4 space-y-5">
      {/* Agent selector */}
      <div>
        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">
          De
        </label>
        <select
          value={sentByAgentId}
          onChange={(e) => onAgentChange(parseInt(e.target.value))}
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
        >
          {agents.map((agent) => (
            <option key={agent.id} value={agent.id}>
              {agent.name}
            </option>
          ))}
        </select>
      </div>

      {/* Delivery Style */}
      <div>
        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">
          Estilo de Entrega
        </label>
        <ToggleOptionList
          options={[
            { value: 'badge', label: 'Emblema', icon: <BadgeGlyph className="w-4 h-4" /> },
            { value: 'snippet', label: 'Pr\u00e9via', icon: <SnippetGlyph className="w-4 h-4" /> },
            { value: 'full', label: 'Completa', icon: <FullMessageGlyph className="w-4 h-4" /> },
          ]}
          value={deliveryStyle}
          onChange={(v) => onDeliveryStyleChange(v as 'badge' | 'snippet' | 'full')}
        />
      </div>

      {/* Collect email */}
      <div>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={collectEmail}
            onChange={(e) => onCollectEmailChange(e.target.checked)}
            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <span className="text-sm text-gray-700">
            Coletar e-mail
          </span>
        </label>
        <p className="mt-1 text-xs text-gray-500 ml-6">
          Solicitar e-mail de visitantes an\u00f4nimos
        </p>
      </div>
    </div>
  )
}
